import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/da20k0tv7gurs51ef2jg";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // anti-spam honeypot check
    const honeypot = (formData.get("website_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      form.reset();
      return;
    }

    const message = (formData.get("message") as string) || "";
    if (message.length > 500) {
      setStatus("error");
      setFormError("留言内容不能超过500字，请精简后再提交。");
      return;
    }

    // remove empty honeypot from payload
    formData.delete("website_alt");

    const data = Object.fromEntries(formData.entries()) as Record<string, string>;

    setStatus("submitting");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText;
      if (!res.ok || parsed?.code !== "OK" || /spam/i.test(serverMsg)) {
        setStatus("error");
        setFormError(serverMsg && serverMsg !== responseText ? serverMsg : "提交失败，请稍后重试。");
        return;
      }
      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form data-readdy-form="吃瓜视频网-联系我们" onSubmit={handleSubmit} className="space-y-4" noValidate>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="cf-name" className="block text-sm text-foreground-700 mb-1.5">您的称呼</label>
          <input
            id="cf-name"
            name="name"
            type="text"
            required
            placeholder="怎么称呼您"
            className="w-full bg-background-50 border border-background-300 rounded-md px-3.5 py-2.5 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
          />
        </div>
        <div>
          <label htmlFor="cf-email" className="block text-sm text-foreground-700 mb-1.5">联系邮箱</label>
          <input
            id="cf-email"
            name="email"
            type="email"
            required
            placeholder="用于接收回复"
            className="w-full bg-background-50 border border-background-300 rounded-md px-3.5 py-2.5 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
          />
        </div>
      </div>
      <div>
        <label htmlFor="cf-type" className="block text-sm text-foreground-700 mb-1.5">联系类型</label>
        <select
          id="cf-type"
          name="type"
          className="w-full bg-background-50 border border-background-300 rounded-md px-3.5 py-2.5 text-sm outline-none focus:border-primary-400"
        >
          <option>投稿爆料</option>
          <option>内容反馈</option>
          <option>商务合作</option>
          <option>其他咨询</option>
        </select>
      </div>
      <div>
        <label htmlFor="cf-message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          required
          maxLength={500}
          placeholder="请描述您想爆料或反馈的内容（500字以内）"
          className="w-full bg-background-50 border border-background-300 rounded-md px-3.5 py-2.5 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400 resize-none"
        />
        <p className="mt-1 text-[11px] text-foreground-500 text-right">最多500字</p>
      </div>

      {/* anti-spam honeypot */}
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="contact-honeypot"
      />

      {status === "error" && formError && (
        <p className="text-sm text-primary-600 bg-primary-50 border border-primary-200 rounded-md px-3 py-2" role="alert">
          <i className="ri-error-warning-line mr-1"></i>{formError}
        </p>
      )}
      {status === "success" && (
        <p className="text-sm text-secondary-800 bg-secondary-50 border border-secondary-200 rounded-md px-3 py-2">
          <i className="ri-checkbox-circle-line mr-1"></i>提交成功！感谢您的留言，我们会尽快与您联系。
        </p>
      )}

      <button
        type="submit"
        disabled={status === "submitting"}
        className="w-full sm:w-auto whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors disabled:opacity-60"
      >
        {status === "submitting" ? (
          <>
            <i className="ri-loader-4-line animate-spin"></i>提交中...
          </>
        ) : (
          <>
            <i className="ri-send-plane-line"></i>提交留言
          </>
        )}
      </button>
    </form>
  );
}